<a
  [routerLink]="['/my-recipes']"
  routerLinkActive="active"
>
  <span class="text">{{ 'Мої рецепти' | translate }}</span>
</a>
